import React, { useState, useEffect } from 'react';

import { makeStyles, Container, Grid, Paper, Tabs, Tab, IconButton } from '@material-ui/core';
import BreadCrumb from 'app/components/BreadCrumb';
import CustomPaginationActionsTable from 'app/components/TableList/TableList';
import { injectIntl, FormattedMessage } from 'react-intl';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';

import styles from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVehicles } from 'app/store/slices/company';
import moment from 'moment';
import { errorHandler } from 'app/utils/errorHandler';
import ModalDocuments from 'app/components/ModalDocuments';
const useStyles = makeStyles(styles);

const LinkDocumento = ({ classes, content, openModal }) => {
  const handleClick = () => {
      openModal(content);
  };

  if (!content.documentos || content.documentos.length === 0) return <></>;
  return (
    <>
      <IconButton
        color="primary"
        className={classes.iconDocument}
        size="small"
        onClick={() => handleClick()}
      >
        <InsertDriveFileIcon className={classes.icon} />
      </IconButton>
    </>
  );
};

function VehiclesList(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState({});

  const [open, setOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState({});

  const openModal = item => {
    setSelectedVehicle(item);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedVehicle({});
    setOpen(false);
  };

  const vehicles = useSelector(state => state.company.vehicles);

  const { intl } = props;

  const prepareData = content => {
    return {
      originalData: content,
      data_solicitacao: <></>,
      dePlaca: <>{content.dePlaca}</>,
      nuOrdemEmpresa: <>{content.nuOrdemEmpresa}</>,
      dtCadastro: <>{moment.utc(content.dtCadastro).format('DD/MM/YYYY')}</>,
      deUtilizacao: <>{content.deUtilizacao}</>,
      deTipoVeiculo: <>{content.deTipoVeiculo}</>,
      deClassificacaoVeiculo: <>{content.deClassificacaoVeiculo}</>,
      vencimento_vistoria: <>{content.dtVencimentoVistoria ? moment.utc(content.dtVencimentoVistoria).format('DD/MM/YYYY') : ''}</>,
      document: (
        <LinkDocumento {...props} classes={classes} content={content} openModal={openModal} />
      ),
    };
  };

  useEffect(() => {
    setLoading(true);
    const findRequests = async () => {
      try {
        const search = { page: page, size: pageSize, request: { ...filters } };
        await dispatch(fetchVehicles(search));
      } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
      }
      setLoading(false);
    };
    findRequests();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters, page, pageSize]);

  useEffect(() => {
    const rows = [];
    if (vehicles.content) {
      vehicles.content.forEach(cont => {
        rows.push(prepareData(cont));
      });
    }
    setRows(rows);
    setPagination(vehicles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicles]);

  const handleChangeFilter = (key, value) => {
    const temp = { ...filters };
    temp[key] = value;
    setFilters(temp);
  };

  const onChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const onChangeRowsPerPage = event => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onBlurSearch = event => {
    handleChangeFilter('txtBusca', event.target.value);
    setPage(0);
  };

  const handleClickRow = (e, row) => {};

  const onChangeSearch = event => {};

  const columns = [
    { title: 'Placa', field: 'dePlaca', align: 'left' },
    { title: 'No de Ordem', field: 'nuOrdemEmpresa', align: 'left' },
    { title: 'Data de inclusão', field: 'dtCadastro', align: 'left' },
    { title: 'Utilização', field: 'deUtilizacao', align: 'left' },
    { title: 'Tipo de veículo', field: 'deTipoVeiculo', align: 'left' },
    { title: 'Classificação', field: 'deClassificacaoVeiculo', align: 'left' },
    { title: 'Vencimento Vistoria', field: 'vencimento_vistoria', align: 'left' },
    { title: '', field: 'document', align: 'left' },
  ];

  const breadCrumb = [
    {
      title: intl.formatMessage({ id: 'LABELS.VEHICLES.VEHICLES' }),
      path: '',
    },
  ];

  const renderTabs = () => {
    return (
      <Grid container spacing={3} className={classes.tabsContainer}>
        <Tabs
          variant="fullWidth"
          className={classes.tabs}
          indicatorColor="primary"
          textColor="primary"
          value={0}
        >
          <Tab className={classes.tab} label={<FormattedMessage id="LABELS.COMMONS.ACTIVE" />} />
        </Tabs>
      </Grid>
    );
  };

  return (
    <>
      <ModalDocuments
        title={`Documentos`}
        type="veiculos"
        open={open}
        onClose={handleClose}
        data={selectedVehicle}
      />
      <Container>
        <BreadCrumb breadCrumb={breadCrumb} />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.container} elevation={3}>
              {renderTabs()}
              <CustomPaginationActionsTable
                loading={loading}
                columns={columns}
                rows={rows}
                placeholderSearch="Busca"
                pagination={pagination}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                onBlurSearch={onBlurSearch}
                onChangeSearch={onChangeSearch}
                onClickRow={handleClickRow}
                hideOrder={true}
                hideItemOrder={true}
                hideInitialDate={true}
                hideFinalDate={true}
              />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default injectIntl(VehiclesList);
